module.exports = __webpack_public_path__ + "static/media/S (29).9b4da655.jpg";